import { t } from 'utils/getTranslations';
import { TOOLBAR_SHADOW } from './toolbarStyles';

export function ChangesCountPill({ count, inTransaction }: { count: number; inTransaction: boolean }) {
    return (
        <div
            className={`bg-paper flex items-center gap-2 rounded-full px-3.5 py-[7px] whitespace-nowrap ${TOOLBAR_SHADOW}`}
        >
            <span className="bg-success size-[7px] rounded-full" />
            <span className="text-grey-600 text-[13px]">
                <span className="text-fg font-semibold">{count}</span>{' '}
                {inTransaction ? t('audit-trail.changes-in-transaction') : t('audit-trail.changes-count')}
            </span>
        </div>
    );
}
